import React, { useState } from 'react';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import './StallForm.css';

import UploadB from "../../../Assets/Upload B.png";
import SavedChangesImg from "../../../Assets/Group 36938.png";
import { FaRegClock } from "react-icons/fa";
import InputError from '../../../Component/InputError/InputError';

import { useAdminAuth } from '../../../ContextAPI/AdminContex';
import { decodeJWT } from '../../../Utils/DecodeJWT';

function ToastMessage({ message }) {
  return (
    <div style={{
      position: "fixed",
      top: "20px",
      right: "20px",
      background: "#4BB543",
      color: "#fff",
      padding: "12px 18px",
      borderRadius: "8px",
      zIndex: 9999,
      fontWeight: "600"
    }}>
      {message}
    </div>
  );
}

export default function AddOutlet() {
  const navigate = useNavigate();
  const location = useLocation();
  const owner_id = location.state?.owner_id;

  const { admin } = useAdminAuth();
  const decoded = admin?.token ? decodeJWT(admin.token) : null;
  const admin_id = decoded?.id || decoded?.admin_id || decoded?.sub || null;

  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showTimePicker, setShowTimePicker] = useState(false);
  const [activeField, setActiveField] = useState("");

  const [selectedHour, setSelectedHour] = useState("09");
  const [selectedMinute, setSelectedMinute] = useState("00");
  const [selectedPeriod, setSelectedPeriod] = useState("AM");

  const [openingTime, setOpeningTime] = useState("");
  const [closingTime, setClosingTime] = useState("");
  const [totalOpenTime, setTotalOpenTime] = useState("");

  const [outletName, setOutletName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [isAvailable, setIsAvailable] = useState(true);
  const [errors, setErrors] = useState({});

  const hours = ["01","02","03","04","05","06","07","08","09","10","11","12"];
  const minutes = ["00","05","10","15","20","25","30","35","40","45","50","55"];
  const periods = ["AM", "PM"];
  const API_BASE = "https://fliplyn-b-c.fly.dev";

  const openPicker = (field) => {
    setActiveField(field);
    setShowTimePicker(true);
  };

  const convertTo24Hour = (hour, minute, period) => {
    let h = parseInt(hour);
    if (period === "PM" && h !== 12) h += 12;
    if (period === "AM" && h === 12) h = 0;
    return { h, minute: parseInt(minute) };
  };

  const calculateTotalHours = (open, close) => {
    if (!open || !close) return "";
    const [oTime, oPeriod] = open.split(" ");
    const [cTime, cPeriod] = close.split(" ");
    const [oHour, oMin] = oTime.split(":");
    const [cHour, cMin] = cTime.split(":");
    const o = convertTo24Hour(oHour, oMin, oPeriod);
    const c = convertTo24Hour(cHour, cMin, cPeriod);

    let start = o.h * 60 + o.minute;
    let end = c.h * 60 + c.minute;
    if (end < start) end += 24 * 60;

    const diff = end - start;
    const hrs = Math.floor(diff / 60);
    const mins = diff % 60;

    return `${hrs} hrs ${mins === 0 ? "" : mins + " mins"}`;
  };

  const applyTime = () => {
    const formatted = `${selectedHour}:${selectedMinute} ${selectedPeriod}`;
    if (activeField === "opening") setOpeningTime(formatted);
    else setClosingTime(formatted);
    setShowTimePicker(false);

    const total = calculateTotalHours(
      activeField === "opening" ? formatted : openingTime,
      activeField === "closing" ? formatted : closingTime
    );
    setTotalOpenTime(total);
  };

  const validateForm = () => {
    let newErrors = {};
    if (!outletName.trim()) newErrors.outletName = "Outlet name is required";
    if (!image) newErrors.image = "Image is required";
    if (!description.trim()) newErrors.description = "Description is required";
    if (!openingTime) newErrors.openingTime = "Opening time required";
    if (!closingTime) newErrors.closingTime = "Closing time required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isFormValid = outletName && description && image && openingTime && closingTime;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!admin_id) {
      alert("Admin ID missing — Cannot create stall!");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("name", outletName);
    formData.append("description", description);
    formData.append("admin_id", admin_id);
    formData.append("owner_id", owner_id);
    formData.append("opening_time", openingTime);
    formData.append("closing_time", closingTime);
    formData.append("is_available", isAvailable);
    formData.append("file", image);

    try {
      // 🔥 Removed unused variable to fix ESLint warning
      await axios.post(`${API_BASE}/stalls/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setShowToast(true);
      setTimeout(() => setShowToast(false), 1800);
      setTimeout(() => navigate("/list-stalls", { state: { owner_id } }), 1200);

    } catch (error) {
      console.error("❌ ERROR:", error.response?.data);
      alert("Failed to create stall. Check console.");
    }

    setLoading(false);
  };


  return (
    <div className="add-outlet-page">
      {showToast && <ToastMessage message="Stall created successfully!" />}
      <AdminHeader />

      <main className="stalls-create-container">
        <div className="page-header">
          <h1>Add New Outlet</h1>
          <button className="btn view-stalls" onClick={() => navigate("/list-stalls")}>
            View Stalls
          </button>
        </div>

        <form className="card form-card" onSubmit={handleSubmit}>
          {/* Outlet Information */}
          <section className="section">
            <h3 className="section-title">Outlet Information</h3>

            <div className="two-cols">
              <div className="field">
                <label>Outlet Name <span className="required">*</span></label>
                <input
                  type="text"
                  placeholder="Enter Outlet name"
                  value={outletName}
                  onChange={(e) => setOutletName(e.target.value)}
                />
                <InputError message={errors.outletName} />
              </div>

              <div className="field upload">
                <label>Upload Image <span className="required">*</span></label>
                <div
                  className="upload-box-stall"
                  onClick={() => document.getElementById("imageInput").click()}
                >
                  {image ? (
                    <img
                      src={URL.createObjectURL(image)}
                      alt="preview"
                      className="upload-preview"
                    />
                  ) : (
                    <>
                      <img src={UploadB} alt="Upload" className="upload-image" />
                      <p>Upload image</p>
                    </>
                  )}
                </div>

                <input
                  id="imageInput"
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => setImage(e.target.files[0])}
                />

                <InputError message={errors.image} />
              </div>
            </div>

            <div className="field full">
              <label>Description<span className="required">*</span></label>
              <textarea
                placeholder="Short description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <InputError message={errors.description} />
            </div>
          </section>

          {/* Timing Section */}
          <section className="section">
            <h3 className="section-title">Timing & Availability</h3>

            <div className="two-cols">
              <div className="field small time-field">
                <label>Opening Time<span className="required">*</span></label>
                <div className="time-input-wrapper">
                  <input
                    type="text"
                    readOnly
                    placeholder="HH:MM"
                    value={openingTime}
                    onClick={() => openPicker("opening")}
                  />
                  <FaRegClock className="time-icon" onClick={() => openPicker("opening")} />
                </div>
                <InputError message={errors.openingTime} />
              </div>

              <div className="field small time-field">
                <label>Closing Time<span className="required">*</span></label>
                <div className="time-input-wrapper">
                  <input
                    type="text"
                    readOnly
                    placeholder="HH:MM"
                    value={closingTime}
                    onClick={() => openPicker("closing")}
                  />
                  <FaRegClock className="time-icon" onClick={() => openPicker("closing")} />
                </div>
                <InputError message={errors.closingTime} />
              </div>
            </div>

            {totalOpenTime && (
              <p className="total-hours">
                Total Open Hours: <strong>{totalOpenTime}</strong>
              </p>
            )}

            <div className="availability-row">
              <span>Availability</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isAvailable}
                  onChange={(e) => setIsAvailable(e.target.checked)}
                />
                <span className="slider" />
              </label>
            </div>
          </section>

          <div className="form-actions">
            <div className="unsaved">
              <img src={SavedChangesImg} alt="Unsaved" className="unsaved-img" />
              <p className='unsaved-chg'>Unsaved changes</p>
            </div>

            <div className="buttons">
              <button type="button" className="btn cancel">Cancel</button>

              <button
                type="submit"
                className="btn create"
                disabled={!isFormValid || loading}
              >
                {loading ? "Creating..." : "Create Stall"}
              </button>
            </div>
          </div>
        </form>
      </main>

      {showTimePicker && (
        <div className="time-picker-overlay">
          <div className="time-popup">
            <h3>Select Time</h3>

            <div className="time-scroll-box">
              <div className="scroll-col">
                {hours.map((h) => (
                  <div
                    key={h}
                    className={`scroll-item ${h === selectedHour ? "active" : ""}`}
                    onClick={() => setSelectedHour(h)}
                  >
                    {h}
                  </div>
                ))}
              </div>

              <div className="scroll-col">
                {minutes.map((m) => (
                  <div
                    key={m}
                    className={`scroll-item ${m === selectedMinute ? "active" : ""}`}
                    onClick={() => setSelectedMinute(m)}
                  >
                    {m}
                  </div>
                ))}
              </div>

              <div className="scroll-col">
                {periods.map((p) => (
                  <div
                    key={p}
                    className={`scroll-item ${p === selectedPeriod ? "active" : ""}`}
                    onClick={() => setSelectedPeriod(p)}
                  >
                    {p}
                  </div>
                ))}
              </div>
            </div>

            <div className="picker-buttons">
              <button className="cancel-btn" onClick={() => setShowTimePicker(false)}>Cancel</button>
              <button className="done-btn" onClick={applyTime}>Done</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
